import React, { useEffect, useState } from 'react';
import axios from 'axios';
import authHeader from "../services/AuthHeader";
import TableDisplay from './TableDisplay';
import { Button } from 'react-bootstrap';
import EditAdminModal from './EditAdminModal';
import DeleteAdminModal from './DeleteAdminModal';
import { useHistory } from "react-router-dom";

const ManageAdmin = (props) => {
    let history = useHistory();
    const initUser ={
            starId: '',
            firstName: '',
            lastName: '',
            email: ''
        };
    const [displayUsers, setDisplayUsers] = useState([]);
        
    const heading = ["Star Id", "First Name", "Last Name", "Email"];
    
    const [modalShow, setModalShow] = useState(false);
    const [modalDeleteShow, setModalDeleteShow] = useState(false);
    
    const [user, setUser] = useState(initUser);
    
    const [mode, setMode] = useState("");
    const [rerender, setRerender] = useState(false);
    
    const modalHide = ()=>{  
        setModalShow(false);
    }
    
    const showModal = ()=>{
        setModalShow(true)
    }
    
    const modalDeleteHide = ()=>{   
        setModalDeleteShow(false);
    }
    
    const showDeleteModal = ()=>{
        setModalDeleteShow(true)
    }
        
    useEffect(()=>{
        axios.get(
            process.env.REACT_APP_API_BASE + 'adminlist/',{ headers: authHeader() }
          )
        .then(res=>{
            let unitList = res.data.map((val,i)=>{
                return(<>
                <tr key={val.starId}>
                    <td key='0' width="10%">{val.starId}</td>
                    <td key='1' width="25%">{val.firstName}</td>
                    <td key='1' width="30%">{val.lastName}</td>
                    <td key='2' width="40%">{val.email}</td>
                    <td key='5' width="5%">
                        <Button key={val.userId} className = 'btn btn-default' 
                        onClick={() => 
                            {
                            setMode("DELETE")
                            showDeleteModal()
                            setUser(val)
                            }
                            }>REMOVE</Button>
                    </td>
                                   
                </tr>
                </>);
            });
            setDisplayUsers(unitList);
            setRerender(false);
        });   
    }, [rerender]);

return  (<>
    <h1 className='h2'>Manage Admins</h1>
    <TableDisplay tableHeading = {heading} tableData = {displayUsers}/>
    <EditAdminModal mode = {mode} show = {modalShow} user= {user}
     onHide = {modalHide} setRerender={setRerender}
    />
    <DeleteAdminModal mode = {mode} show = {modalDeleteShow} user= {user}
     onHide = {modalDeleteHide} setRerender={setRerender}
    />
    <Button className="btn btn-default" type="button" onClick = {()=> {
                                                    setUser(initUser)
                                                    showModal()
                                                    setMode("ADD")}}>Add new {[props.unitType]}</Button>
    <Button style={{marginLeft: '20px'}} className="btn btn-default" type="button" onClick={() => history.goBack()}>Back</Button>    
</>); 
}

export default ManageAdmin;
